<template>
    <div>
        <v-row>
            <v-col>
                <h4 class="text-h4">Sales Invoices</h4>
                <p class="subtitle-1">List of Sales Invoices</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-card flat>
            <v-card-title>
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    v-if="haveSelectedInvoice"
                    @click="openInvoiceDisplayDialog()">
                    <v-icon>mdi-eye</v-icon>
                </v-btn>
                <v-btn
                    icon
                    @click="getInvoices()">
                    <v-icon>mdi-refresh</v-icon>
                </v-btn>
                <v-menu offset-y :close-on-content-click="false" v-model="display.search">
                    <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                    </template>
                    <SalesInvoiceSearchMenu :loading="loading.data" :close="!loading.data" @submit="SalesInvoiceSearchMenuSubmit" />
                </v-menu>
                <!-- <v-menu
                    offset-y
                    :close-on-content-click="false"
                    >
                    <template v-slot:activator="{on: menu}">
                        <v-tooltip bottom="">
                            <template v-slot:activator="{on: tooltip}">
                                <v-btn
                                    icon
                                    v-on="{...menu, ...tooltip}"
                                    class="mx-1">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t("search") }}</span>
                        </v-tooltip>
                    </template>
                    <v-text-field
                        autofocus
                        :label="$t('search')"
                        solo
                        v-model="search"
                        @keypress.enter="getInvoices()"
                        hide-details>
                    </v-text-field>
                </v-menu> -->
                <v-menu
                    offset-y>
                    <template v-slot:activator="{on}">
                        <v-btn
                            icon
                            v-on="on"
                            class="mx-1">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list width="250" dense>

                        <v-list-item
                            :disabled="authorizations.invoices ? !authorizations.invoices.create : true"
                            @click="openInvoiceDialog()"
                            link>
                            <v-list-item-icon>
                                <v-icon :disabled="authorizations.invoices ? !authorizations.invoices.create : true">mdi-database-plus</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('new_invoice') }}</v-list-item-title>
                        </v-list-item>

                        <v-divider v-if="haveSelectedInvoice"></v-divider>
                        <v-list-item
                            v-if="haveSelectedInvoice && authorizations.invoices.read"
                            @click="openInvoiceDisplayDialog()"
                            link>
                            <v-list-item-icon>
                                <v-icon>mdi-eye</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('show_invoice') }}</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            :disabled="!getSelectedInvoice.meta.editable"
                            v-if="haveSelectedInvoice && authorizations.invoices.update"
                            @click="openInvoiceEditDialog()"
                            link
                            >
                            <v-list-item-icon>
                                <v-icon :disabled="!getSelectedInvoice.meta.editable">mdi-pencil</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('edit_invoice') }}</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-if="haveSelectedInvoice && authorizations.invoices.delete"
                            :disabled="!getSelectedInvoice.meta.deletable"
                            @click="openInvoiceDeleteDialog()"
                            link>
                            <v-list-item-icon>
                                <v-icon :disabled="!getSelectedInvoice.meta.deletable">mdi-delete</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('delete_invoice') }}</v-list-item-title>
                        </v-list-item>

                    </v-list>
                </v-menu>
            </v-card-title>
            <v-card-text>
                <InvoicesDataTable
                    ref="invoicesDataTable"
                    :data="invoices"
                    :loading="loading.data"
                    :length="length.invoices"
                    :pagination="true"
                    @selected:row="setSelected"
                    @selected:clear="clearSelected"
                    @updated="getInvoices"
                    @updated:invoice="getInvoices"
                    :options.sync="options"
                    />
            </v-card-text>
        </v-card>
        <InvoiceDialog
            v-if="invoiceDialogDisplay"
            :id="invoiceDialog.id"
            @submit="onInvoiceDialogSubmit"
            @close="closeInvoiceDialog"/>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { formatMoney } from 'accounting';
import { isEmpty } from 'lodash';

import InvoicesDataTable from '../../components/Sales/InvoicesDataTable';
import InvoiceDialog from '@/components/Sales/InvoiceDialog';
import SalesInvoiceSearchMenu from '../../components/Sales/SalesInvoiceSearchMenu';

import { getInvoices } from "../../services/sales/invoice";
export default {
    name: "Invoices",
    components: {
        InvoiceDialog,
        InvoicesDataTable,
        SalesInvoiceSearchMenu,
    },
    data() {
        return {
            invoices: [],
            loading: {
                data: false
            },
            selected: {
                invoice: {}
            },
            length: {
                invoices: 0
            },
            search: null,
            invoiceDialog: {
                id: null,
                display: false
            },
            options: {
                itemsPerPage: 10
            },
            display: {
                search: false
            }
        }
    },
    computed: {
        ...mapState('authentication', ["authorizations"]),
        invoiceDialogDisplay() {
            return this.invoiceDialog.display;
        },
        haveSelectedInvoice() {
            return isEmpty(this.selected.invoice) ? false : true;
        },
        getSelectedInvoice() {
            return this.selected.invoice;
        },
    },
    watch: {
        options: {
            handler() {
                this.getInvoices();
            }
        }
    },
    methods: {
        formatMoney,
        ...mapActions('sales/invoice', ["fetchInvoices",'removeInvoice']),
        async getInvoices() {
            this.loading.data = true ;
            let options = {...this.options, search: this.search};
            let result = await this.fetchInvoices(options);
            this.invoices = result.data.data;
            this.length.invoices = result.data.total;
            this.loading.data = false;
        },
        setSelected(invoice) {
            this.selected.invoice = invoice;
        },
        clearSelected() {
            this.selected.invoice = {};
        },
        openInvoiceDialog() {
            this.invoiceDialog.id = null;
            this.invoiceDialog.display = true;
        },
        closeInvoiceDialog() {
            this.invoiceDialog.display = false;
        },
        onInvoiceDialogSubmit() {
            this.closeInvoiceDialog();
            this.getInvoices();
        },
        openInvoiceDeleteDialog() {
            this.$refs.invoicesDataTable.openInvoiceDeleteDialog();
        },
        openInvoiceDisplayDialog() {
            this.$refs.invoicesDataTable.openInvoiceDisplayDialog();
        },
        openInvoiceEditDialog() {
            this.$refs.invoicesDataTable.openInvoiceEditDialog();
        },
        async SalesInvoiceSearchMenuSubmit(search) {
            this.options = {...this.options, ...search};
            let response = await getInvoices(this.options);
            this.invoices = response.data.data;
            this.length.invoices = response.data.total;
        }
    },
    created() {
        // this.getInvoices();
    }
}
</script>